// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"596":"4f6330dc","651":"4f6330dc","718":"67d91c61","860":"f10819e9"}[chunkId] + ".css";
};